import { render } from "./TrinketGrid.vue?vue&type=template&id=632897b7&scoped=true&ts=true"
import script from "./TrinketGrid.vue?vue&type=script&lang=ts"
export * from "./TrinketGrid.vue?vue&type=script&lang=ts"

import "./TrinketGrid.vue?vue&type=style&index=0&id=632897b7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632897b7"]])

export default __exports__